import { createReducer, on, createFeature } from '@ngrx/store'
import { PayrollState } from './contractor-payroll.state'
import { contractorPayrollBatchesActions, runningCPActions } from './contractor-payroll.actions'

const initialState: PayrollState = {
  payrollBatches: null,
  runningPayroll: null,
  //previousSalaries: null,
  //arrearLopDays: null,
  //tdsCalculationBatch: null,
  //tdsCalculation: null,
  //isTdsPreviewLoading: false,
  contractorPayrollData: null,
  //latestUserPayrollDate: null,
  //PayrollSummary: null,
  loading: false,
  error: null
}

export const contractorPayrollReducer = createReducer(
  initialState,
  on(contractorPayrollBatchesActions.loadBatchesSuccess, (state, { payrollBatches }) => ({
    ...state,
    payrollBatches
  })),
  on(runningCPActions.clearRunningPayroll, state => ({
    ...state,
    runningPayroll: null
  })),
  on(runningCPActions.setupRunningPayroll, (state, { batchData }) => ({
    ...state,
    runningPayroll: batchData
  })),
  on(runningCPActions.loadRunningPayrollSuccess, (state, { updatedBatch }) => ({
    ...state,
    runningPayroll: updatedBatch
  })),
  //on(runningCPActions.loadPreviousSalariesSuccess, (state, { previousSalaries }) => ({
  //  ...state,
  //  previousSalaries
  //})),
  //on(runningCPActions.clearPreviousSalaries, state => ({
  //  ...state,
  //  previousSalaries: null
  //})),
  //on(runningCPActions.loadArrearLopDaysSuccess, (state, { arrearLopDays }) => ({
  //  ...state,
  //  arrearLopDays
  //})),
  //on(runningCPActions.clearArrearLopDays, state => ({
  //  ...state,
  //  arrearLopDays: null
  //})),
  //on(tdsCalculationActions.loadBatchTdsPreviewSuccess, (state, tdsResults) => ({
  //  ...state,
  //  tdsCalculationBatch: tdsResults
  //})),
  //on(tdsCalculationActions.loadTdsPreviewSuccess, (state, tdsResult) => ({
  //  ...state,
  //  tdsCalculation: tdsResult
  //})),
  on(runningCPActions.saveRunningCPBatchSuccess, (state, { batchData }) => ({
    ...state,
    runningPayroll: batchData
  })),
  on(runningCPActions.updateRunningPayrollStatusSuccess, (state, { batchData }) => ({
    ...state,
    runningPayroll: batchData
  })),
  on(contractorPayrollBatchesActions.finalizePayrollSuccess, (state, { batch }) => ({
    ...state,
    payrollBatches:
      state.payrollBatches?.map(batchData => {
        if (batchData.id === batch.id) {
          return batch
        }
        return batchData
      }) ?? null
  })),
  on(contractorPayrollBatchesActions.deletePayrollBatchSuccess, (state, { id }) => {
    const updatedBatches = state.payrollBatches?.filter(batch => batch.id !== id) || []
    return {
      ...state,
      payrollBatches: updatedBatches.length > 0 ? updatedBatches : null
    }
  })
  //on(userPayrollActions.loadUserPayrollSuccess, (state, { payroll }) => ({
  //  ...state,
  //  userPayrollData: payroll
  //})),
  //on(userPayrollActions.loadLatestUserPayrollDateSuccess, (state, { latestPayrollDate }) => ({
  //  ...state,
  //  latestUserPayrollDate: latestPayrollDate
  //})),
  //on(userPayrollActions.loadLatestUserPayrollDateFailure, (state, { error }) => ({
  //  ...state,
  //  latestUserPayrollDate: null,
  //  error
  //})),
  //on(payrollSummaryActions.loadSummarySuccess, (state, { summary }) => ({
  //  ...state,
  //  PayrollSummary: summary
  //}))
)

export const contractorPayrollFeature = createFeature({
  name: 'contractorPayroll',
  reducer: contractorPayrollReducer
})

export const {
  selectPayrollBatches,
  selectRunningPayroll,
  //selectPreviousSalaries,
  //selectArrearLopDays,
  //selectTdsCalculationBatch,
  //selectTdsCalculation,
  //selectIsTdsPreviewLoading,
  selectContractorPayrollData,
  //selectLatestUserPayrollDate,
  //selectPayrollSummary,
  selectLoading,
  selectError
} = contractorPayrollFeature
